// Retry if lazy loading fails due to poor internet connection
// https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
export const retry = (fn: any, retriesLeft = 3, interval = 500) => (
  new Promise<any>(
    (resolve: (result: Promise<any> | any) => void, reject: (error?: any) => void) =>
      fn()
        .then(resolve)
// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
        .catch((error) =>
          setTimeout(() => {
            // reject when maximum tries have been exceeded
            if (retriesLeft <= 1) return reject(error)

            retry(fn, retriesLeft - 1, interval).then(resolve, reject)
          }, interval)
        ),
  )
)
